<template>
  <div class="weblink">
    <pb-result
      v-if="url"
      icon="emptyOk"
      class="result"
      :title="$t('Gattaran_lowcode_dTZL_JDSp') /** 已打开新窗口，请在浏览器中查看 */"
    />
    <pb-result
      v-else
      icon="404"
      :title="
        $t(
          'Gattaran_lowcode_axmA_FvoV',
        ) /** 未获取到要跳转页面的URL，请点击重试或联系平台管理员处理 */
      "
      class="result"
    >
      <template slot="extra">
        <pb-button type="primary" size="medium" @click="reload">{{
          $t('FoodD_one_Try_again_qZka' /**重试 */)
        }}</pb-button>
      </template>
    </pb-result>
  </div>
</template>
<script>
export default {
  name: 'Weblink',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {
    if (this.url) {
      window.open(this.url);
    }
  },
  methods: {
    reload() {
      location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.weblink {
  height: calc(100% - 56px);
  padding: 16px;
  .result {
    background: #fff;
    height: 100%;
    ::v-deep .pb-result__icon {
      svg {
        width: 256px;
        height: 256px;
      }
    }
    ::v-deep .pb-result__title {
      font-size: 24px;
    }
  }
}
</style>
